import Section from '../Section';
import FlatItem from './FlatItem';

/**
 * Converts deep nested section data to flat
 *
 * @param {Array<Section>} sections
 * @return {Array<FlatItem>}
 */
export default function sectionsToFlatItems(sections: Section[]): FlatItem[] {
    return sections.reduce((accumulator, section) =>
        [
            ...accumulator,
            {
                text: section.label,
                type: (section.persistent ? 'persistentSectionHeader' : 'nonPersistentSectionHeader'),
                value: section.label,
            },
            ...section.skuLines.map((skuLine) => ({
                text: skuLine.name + ' (#' + skuLine.skuNumber + ')',
                type: 'rankedSku',
                value: skuLine.skuNumber,
            })),
        ], []
    );
}
